var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.51,
    height: 37.5,
    viewBox: "0 0 37.51 37.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250",
    transform: "translate(565.944 -349.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248",
    transform: "translate(1 0.446)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    y1: 9.287,
    transform: "translate(-547.908 361)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M-529.684,368.21a17.5,17.5,0,0,1-17.509,17.5,17.5,17.5,0,0,1-17.5-17.5,17.5,17.5,0,0,1,17.5-17.5A17.5,17.5,0,0,1-529.684,368.21Z",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M-547.192,355.085A13.127,13.127,0,0,1-534.06,368.21a13.127,13.127,0,0,1-13.132,13.125,13.125,13.125,0,0,1-13.125-13.125,13.1,13.1,0,0,1,5.045-10.344",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    "data-name": "Group 1253",
    transform: "translate(128.191 -0.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(-676.073 374.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M-673.725,375.2a1.171,1.171,0,0,1-1.174,1.174,1.173,1.173,0,0,1-1.174-1.174,1.174,1.174,0,0,1,1.174-1.178A1.172,1.172,0,0,1-673.725,375.2Z",
    transform: "translate(676.073 -374.021)",
    fill: "#2699fb"
  })))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.f10d4024.svg";
export { ForwardRef as ReactComponent };